/* eslint-disable react/prop-types */
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {useState} from "react";
import SoftBadge from "../../../components/SoftBadge";
import {useNavigate} from "react-router-dom";
import Loading from "../../../components/Loading";
import fixTableCellWidth from "../../../functions/fixTableCellWidth";
import useModal from "../../../hooks/useModal";
import SubCategoryModal from "../modal/SubCategoryModal";
import handleDeleteBusinessCategory from "../functions/handleDeleteBusinessCategory";

function createData(id, name, description, operation) {
    return {
        id,
        name,
        description,
        operation
    };
}

function Row(props) {
    const {row} = props;

    return (
        <React.Fragment>
            <TableRow sx={{'& > *': {borderBottom: 'unset'}}}>
                <TableCell className="tablecell" align="left"
                           style={fixTableCellWidth("200px")}>{row.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row.description}
                           style={fixTableCellWidth("320px")}>{row.description}</TableCell>
                <TableCell className="tablecell" align="left" style={{
                    ...fixTableCellWidth("300px"),
                    cursor: "pointer"
                }}>{row.operation}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function BusinessCategoryTable({data}) {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [modals, updateModal, closeModal] = useModal({
        subCategory: {},
    })
    const closeSubCategory = () => closeModal('subCategory');

    const rows = data.map(item => createData(item.id, item.name, item.description,
        <React.Fragment>
            <SoftBadge variant="contained"
                       onClick={() => updateModal("subCategory", {state: true, data: item.sub_categories})}
                       badgeContent="زیر دسته بندی" color="info" size="xs" container style={{marginLeft: 5}}/>
            <SoftBadge variant="contained" badgeContent="آپدیت" color="secondary" size="xs" style={{marginLeft: 5}}
                       container
                       onClick={() => navigate(`/new-business-category?method=update&categoryId=${item.id}`)}/>
            <SoftBadge variant="contained" onClick={()=>handleDeleteBusinessCategory(item.id,setLoading)} badgeContent="حذف" color="error" size="xs" container/>
        </React.Fragment>
    ))

    return (
        <>
            <Loading loading={loading}/>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <SoftBadge variant="contained" onClick={() => navigate("/new-business-category")}
                                   style={{cursor: "pointer"}} badgeContent="دسته بندی جدید" color="success" size="xs"
                                   container/>
                        <TableRow>
                            <TableCell className="tablecell" style={fixTableCellWidth("200px")}>نام</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("300px")}>توضیحات</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("300px")}>عملیات ها</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{display: 'block'}}>
                        {rows.map((row) => (
                            <Row key={row.id} row={row}/>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {modals.subCategory.state &&
                <SubCategoryModal updatePath={"new-business-category"} subCategory={modals.subCategory}
                                  handleDeleteCategory={handleDeleteBusinessCategory}
                                  closeSubCategory={closeSubCategory} setLoading={setLoading}/>}
        </>
    );
}
